import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function VisionSection() {
  return <Section background="ivory" className="text-center py-32 md:py-48" data-id="element-400" data-mp="23p0ev5azilwv">
      <div className="max-w-4xl mx-auto" data-id="element-401" data-mp="1pozctmizh8ft">
        <FadeIn data-id="element-402" data-mp="1pq0tc6irqn4x">
          <div className="w-16 h-[1px] bg-purple-400 mx-auto mb-12" data-id="element-403" data-mp="1pqk5t7pngjbk"></div>
          <h2 className="text-4xl md:text-6xl font-serif text-charcoal leading-tight mb-8" data-id="element-404" data-mp="1uo2jfbem3mpw">
            Rebuilding Wellness <br data-id="element-405" data-mp="2idwtjl7jqx6g" />
            <span className="italic text-charcoal/60" data-id="element-406" data-mp="2ifhh2qvg1fut">Around Women</span>
          </h2>
          <p className="text-xl md:text-2xl text-charcoal/80 font-light leading-relaxed mb-12" data-id="element-407" data-mp="2neas8cn9curt">
            Fem Entity is not just a platform — it is infrastructure for a new
            model of care. Investing in women's health creates a 3x economic
            return, while unlocking healthier communities, stronger workforces,
            and more equitable systems.
          </p>
          <div className="w-16 h-[1px] bg-purple-400 mx-auto" data-id="element-408" data-mp="3640nf0uxnik9"></div>
        </FadeIn>
      </div>
    </Section>;
}